export function buildInteractivePreviewUrl(runtimeUrl: string, runtimeOrigin: string, appId: string): string | undefined {
	try {
		const url = new URL(runtimeUrl);
		if (url.origin !== runtimeOrigin || url.username || url.password || !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(appId))
			return undefined;
		url.searchParams.set('runtimePreview', '1');
		url.searchParams.set('previewApp', appId);
		return url.toString();
	} catch {
		return undefined;
	}
}
